import { Injectable, EventEmitter } from '@angular/core';
import { TicketBase } from '../_interfaces/ticket';
import { BehaviorSubject, Observable } from 'rxjs';
import { AddressBase } from '../_interfaces/address';
import { HttpFunctionResult } from '../_interfaces/HttpFunctionResult';
import { WebConfig } from '../_interfaces/WebConfig';
import { HttpResponse } from '@angular/common/http';
import { HttpService } from './http.service';
import { FeedbackService } from './feedback.service';
import { Platform } from '@ionic/angular';
import { AuthService } from './auth.service';
import { StorageManagerService } from './storage-manager.service';
import { PaymentService } from './payment/payment.service';
import * as semver from "semver"
import { BoardService } from './boards/board.service';

export interface TicketWebInfo {
  Anleitung: string;
  Setup: string;
  SetupBeta: string;
  Version: string;
  VersionBeta: string;
  SetupVersion: string;
  TicketsystemSetup: string;
  TicketsystemSetupUpdate: string;
  iOS: string;
  android: string;
  update_messages?: {version?: string, message?: string}[];
}

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  private _messagesOpen: EventEmitter<boolean> = new EventEmitter<boolean>()
  private _activeTicket: BehaviorSubject<{ticket: TicketBase, workstepId?: number}> = new BehaviorSubject<{ticket: TicketBase, workstepId?: number}>(null);
  private _activeCrm: BehaviorSubject<AddressBase> = new BehaviorSubject<AddressBase>(null)
  private _webConfig: WebConfig
  private _universalTicketId: number
  private _singleTicketLoading: boolean = false

  public ticketWebInfo: TicketWebInfo

  constructor(
    private http: HttpService,
    private feedback: FeedbackService,
    private platform: Platform,
    private boardSrv: BoardService,
    private auth: AuthService,
    private paymentSrv: PaymentService,
    private storageManager: StorageManagerService
  ) {
    
  }

  public serverVersionGreaterThan(checkVersion: string): boolean{
    if(!this?.webConfig?.version) return false
    if(this?.webConfig?.version == checkVersion) return true
    
    return semver.lt(checkVersion, this?.webConfig?.version)
  }

  //AKTICE TICKET
  public get activeTicket(): Observable<{ticket: TicketBase, workstepId?: number}>{
    return this._activeTicket.asObservable()
  }

  public setActiveTicket(ticket: TicketBase, workstepId?: number){ 
    this._activeTicket.next({ticket: ticket, workstepId: workstepId})
  }

  public getTicketValue(): {ticket: TicketBase, workstepId?: number}{
    return this._activeTicket.getValue()
  }

  //UNIVERSAL LINKSs
  public set universalTicketId(ticketId: number){
    this._universalTicketId = ticketId
  }

  public get universalTicketId(){
    return this._universalTicketId
  }

  //ACTIVE CRM
  public get activeCrm(){
    return this._activeCrm.asObservable()
  }

  public setActiveCrm(crm: AddressBase){
    this._activeCrm.next(crm)
  }

  public get activeCrmValue(): AddressBase{
    return this._activeCrm.value
  }

  //MESSAGES OPEN
  public get messageOpen(): EventEmitter<boolean>{
    return this._messagesOpen
  }

  //WebConfig
  public get webConfig(): WebConfig{
    return this._webConfig
  }

  //Ob Ticket am Laden ist

  private singleTicketLoadingAnimationFinishedTimeOut
  private _singleTicketLoadingAnimationFinished: boolean = true

  public get singleTicketLoadingAnimationFinished(): boolean{
    return this._singleTicketLoadingAnimationFinished
  }

  public set singleTicketLoading(value: boolean){
    clearTimeout(this.singleTicketLoadingAnimationFinishedTimeOut)
    if(!value) this.singleTicketLoadingAnimationFinishedTimeOut = setTimeout(() => this._singleTicketLoadingAnimationFinished = true, 400);
    else this._singleTicketLoadingAnimationFinished = false
    this._singleTicketLoading = value
  }

  public get singleTicketLoading(): boolean{
    return this._singleTicketLoading
  }

  public setMessageOpenStatus(value: boolean){
    this._messagesOpen.emit(value)
  }

  public async getWebConfig(): Promise<HttpFunctionResult<WebConfig>>{

      const response: HttpFunctionResult<WebConfig> = await this.http.GET({
        path: "config",
        timeout: 20000, 
        asDataProperty: false
      })

      if(response.success){
        this._webConfig = response.data
        // if(this.auth.getUser().role != "customer" && !this.auth.getUser().role.includes("customer")) if(this._webConfig?.isStandalone) await this.paymentSrv.getBasicSubscription()
        if(this.serverVersionGreaterThan("1.7.0") && this.http?.token) await this.boardSrv.loadTags()
        this.http.requestReady.next(true)
      }
      return response
  }

  public async getTicketPaths(): Promise<HttpFunctionResult<any>>{
      const result: HttpFunctionResult<TicketWebInfo> = await this.http.getTicketPaths()
      if(!result.success) return {success: false} 
      this.ticketWebInfo = result.data
      return {success: true}
  }

  public async deleteSettings(withLogout: boolean = true): Promise<boolean>{
    if(!this.platform.is("capacitor") && !this.platform.is("electron")) return false
    if(!(await this.feedback.confirm("Möchten Sie wirklich die lokalen Einstellungen löschen?", "Löschen", "Abbrechen"))) return
    await this.storageManager.delete("BASEURL")
    await this.storageManager.delete("SETUPCOMPLETE")
    await this.storageManager.delete("SENTRY_ENABLED")
    if(withLogout)await this.auth.logout()
    return true
  }

}
